import { appHomeRoute, isGuestRoute } from "~/routes";

export default defineNuxtRouteMiddleware((to, from) => {
  const { loggedIn } = useAuth();
  if (loggedIn.value && isGuestRoute(to.path)) {
    if (from.path && from.path !== to.path) {
      return navigateTo(from.path);
    }
    return navigateTo(appHomeRoute.path);
  }
});
